if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        // Listen on the element itself — `submit` bubbles up from the inner <form>,
        // and <product-form> always exists. Querying children in the constructor is
        // unreliable (the <form> may not be parsed yet when the element upgrades);
        // that previously left the listener unattached, so the form submitted
        // natively and redirected to /cart instead of opening the side cart.
        this.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      connectedCallback() {
        this.init();
      }

      // Idempotent ref resolution — safe to call from connectedCallback and again
      // on first submit, in case the <form> wasn't present yet at connect time.
      init() {
        if (this.submitButton) return; // already initialised
        if (!this.form) this.form = this.querySelector('form');
        if (!this.form) return;
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;
        var idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // Make sure refs are resolved (the <form> is guaranteed present by now).
        this.init();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // The <cart-drawer> lives in the layout and may be parsed after this
        // <product-form>; resolve it lazily so the add opens the side cart instead
        // of falling through to the cart-page redirect below. CartHandler.add
        // already renders + opens it.
        if (!this.cart) {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }

        /* Validate external inputs linked via form attribute (e.g. gift card email) */
        var formId = this.form.getAttribute('id');
        if (formId) {
          var externalInputs = document.querySelectorAll('[form="' + formId + '"][required]');
          for (var i = 0; i < externalInputs.length; i++) {
            if (!externalInputs[i].checkValidity()) {
              externalInputs[i].reportValidity();
              return;
            }
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const variantId = this.variantIdInput.value;
        const formData = new FormData(this.form);
        const quantity = parseInt(formData.get('quantity')) || 1;

        // Collect line item properties from form inputs with name="properties[...]"
        const properties = {};
        const formEl = this.form;
        // (formId already resolved above from the same form)
        // Include inputs linked via form attribute (outside the <form> element)
        const allInputs = formId
          ? document.querySelectorAll('[form="' + formId + '"], #' + CSS.escape(formId) + ' [name]')
          : formEl.querySelectorAll('[name]');
        allInputs.forEach(function (input) {
          var match = input.name.match(/^properties\[(.+)\]$/);
          if (match && input.value) {
            properties[match[1]] = input.value;
          }
        });

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        CartHandler.add(variantId, quantity, Object.keys(properties).length ? properties : undefined)
          .then((response) => {
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
            }
          })
          .catch((e) => {
            if (e && e.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: e.errors || e.description,
                message: e.message,
              });
              this.handleErrorMessage(e.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
            } else {
              console.error(e);
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
